//Skeleton component

import { cn } from "@/lib/util/utils";

export function Skeleton({ className }: { className?: string }) {
  return (
    <div
      className={cn("animate-pulse rounded-md bg-gray-200", className)}
    ></div>
  );
}
